export const STATE_REQUEST_HASH_KEY = 'stateRequestHash';
export const SET_GLOBAL_STATE_ACTION_KEY = 'SET_GLOBAL_STATE';
